import { render, staticRenderFns } from "./Carousel2Wrapper.vue?vue&type=template&id=7de2dd95&"
import script from "./Carousel2Wrapper.vue?vue&type=script&lang=js&"
export * from "./Carousel2Wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports